import React from 'react';
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import DisplayComponent from './component/Display/DisplayComponent';
import { Route, Routes } from 'react-router-dom';

const theme = createTheme({
  components: {
    // Name of the component
    MuiList: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
        },
      },
    },
  },
  list: {

  }
});

function App(props) {
  return (
    <ThemeProvider theme={theme} >
      <div className="content">
        <Routes>
          <Route exact path="*" element={<DisplayComponent />} />
        </Routes>
      </div>
    </ThemeProvider>

  );
}

export default App;
